var Handlebars = require("../../../node_modules/handlebars/runtime.js");
function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
module.exports = (Handlebars["default"] || Handlebars).template({"1":function(container,depth0,helpers,partials,data) {
    var alias1=container.lambda, alias2=container.escapeExpression;

  return "    <div class=\"video-clipping-thumb\" data-url=\""
    + alias2(alias1((depth0 != null ? depth0.url : depth0), depth0))
    + "\" style=\"background-image:url("
    + alias2(alias1((depth0 != null ? depth0.url : depth0), depth0))
    + "); width:"
    + alias2(alias1((depth0 != null ? depth0.width : depth0), depth0))
    + "%; height: "
    + alias2(alias1((depth0 != null ? depth0.height : depth0), depth0))
    + "px\">\n        \n    </div>\n";
},"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1;

  return "\n\n"
    + ((stack1 = helpers.each.call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? depth0.thumbs : depth0),{"name":"each","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "");
},"useData":true});